import {clsx} from 'clsx'

import styles from './styles.module.css'

export function ItemDivider() {
  return <div className={clsx(styles.itemDivider, 'hide-sm hide-md')} />
}
